import * as React from 'react'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { ReactComponent as IconFacebook } from '../../../assets/svg/icon-facebook.svg'
import { ReactComponent as IconInstagram } from '../../../assets/svg/icon-instagram.svg'
import { ReactComponent as IconHeartFavorite } from '../../../assets/svg/icon-heart-favorite.svg'
import { ReactComponent as IconMenuSearch } from '../../../assets/svg/icon-menu-search.svg'

export default function BrandSettings(props) {
  const ValidationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('This field is required'),
  })

  const handleChangePassword = (values) => {
    console.log(values)
  }
  return (
    <div className="mastcontent mb-[100px]">
      <div className="container mx-auto">
        <div className="mt:8 lg:mt-16">
          <h2 className="font-[CircularStd] text-text-1 mb-6 text-5xl mr-1 uppercase">Settings</h2>

          <div className="flex flex-row justify-between items-start">
            <div className="basis-5/7 bg-surface rounded-xl p-5">
              <h3 className="text-base text-text-1 font-bold mb-3">Invite</h3>

              <Formik
                initialValues={{
                  email: '',
                }}
                validationSchema={ValidationSchema}
                onSubmit={(values) => {
                  handleChangePassword(values)
                }}
              >
                {({ errors, touched }) => (
                  <Form className="w-full">
                    <h3 className="text-error mb-5 font-bold text-center my-2"> Missing functionality </h3>

                    <Field
                      placeholder="Current Password"
                      name="email"
                      type="text"
                      className={`appearance-none text-sm border rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3 ${
                        errors.email && touched.email ? 'border-error' : 'border-border-token'
                      }`}
                    />
                    {errors.email && touched.email ? <div className="text-left text-error text-xs font-bold mt-1 pl-5">{errors.email}</div> : null}

                    <button className="bg-accent text-base text-white mt-12 py-3 px-5 lg:px-10 block rounded-xl focus:outline-none focus:shadow-outline" type="submit">
                      Send invite
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
